module.exports = __webpack_public_path__ + "static/img/013.6f261a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/013.png
// module id = OWQz
// module chunks = 0